import type { IconDef } from '../types';

export const camera: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M17.9404 3C18.7702 3.00023 19.4404 3.67014 19.4404 4.5V5H20C22.21 5 24 6.79 24 9V18C24 20.21 22.21 22 20 22H4C1.79 22 0 20.21 0 18V9C0 6.79 1.79 5 4 5H13.5801V4.5C13.5801 3.67 14.2501 3 15.0801 3H17.9404ZM4.2998 6.65039C3.19003 6.6005 2.26018 7.45983 2.20996 8.55957L1.82031 17.5498C1.77031 18.6598 2.63047 19.5896 3.73047 19.6396L19.71 20.3398C20.81 20.3898 21.74 19.5297 21.79 18.4297L21.7998 18.4199L22.1904 9.42969C22.2402 8.32992 21.38 7.39974 20.2803 7.34961L4.2998 6.65039ZM11.5 9C13.98 9 16 11.02 16 13.5C16 15.98 13.98 18 11.5 18C9.02 18 7 15.98 7 13.5C7 11.02 9.02 9 11.5 9ZM13.2598 11.7305C12.3798 10.8505 10.8704 10.9304 9.90039 11.9004C8.93039 12.8704 8.85047 14.3798 9.73047 15.2598C10.6105 16.1396 12.1199 16.0598 13.0898 15.0898C14.0598 14.1199 14.1396 12.6105 13.2598 11.7305Z',
    },
  ],
};
